import InstallPWA from '../components/InstallPWA';
import LoginForm from '../forms/LoginForm';

import React from "react";


class LoginView extends React.Component {

    /*constructor(){
        super();
    }*/

    

    /**
     * RENDERING
     * @returns dom
     */
    render() { return(
        <div style={{
            margin: "auto",
            width: "360px",
          }}>
            <LoginForm/>
            <InstallPWA/>
             
        </div>
    )}

}

export default LoginView;